import { VIDEO_PLAYER_STOP, VIDEO_PLAYER_PLAY } from './actionTypes'

export const stopVideoPlayer = () => ({
  type: VIDEO_PLAYER_STOP
})

export const playVideoPlayer = () => ({
  type: VIDEO_PLAYER_PLAY
})
